import { useContext } from 'react';
import { Badge } from 'react-bootstrap';
import { UserPendingNotifications } from '../../../api';
import { SessionContext } from '../../contexts/SessionContext';

interface NotificationBadgeProps {
  notificationType: keyof UserPendingNotifications | Array<keyof UserPendingNotifications>;
  className?: string;
}

export const NotificationBadge = ({ notificationType, className }: NotificationBadgeProps) => {
  const { notifications } = useContext(SessionContext);

  const notificationsCount =
    !notifications?.isLoading && notifications?.notifications
      ? Array.isArray(notificationType)
        ? notificationType.reduce(
            (sum, type) => sum + (notifications.notifications?.[type] ?? 0),
            0
          )
        : (notifications.notifications[notificationType] ?? 0)
      : 0;

  if (!notificationsCount) return null;

  return (
    <Badge bg="primary" className={`ms-2 align-middle ${className || ''}`}>
      {notificationsCount}
    </Badge>
  );
};

interface BadgeProps {
  className?: string;
}

export const PendingConnectionRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge notificationType="connection_requests" className={className} />
);

export const PendingPresentationRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge notificationType="connection_responded_requests" className={className} />
);

export const PendingPlacementRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge notificationType="placement_requests" className={className} />
);

export const RespondedPlacementRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge notificationType="placement_responded_requests" className={className} />
);

export const NavBarConnectionRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge
    notificationType={['connection_requests', 'connection_responded_requests']}
    className={className}
  />
);

export const NavBarPlacementRequestsBadge = ({ className }: BadgeProps) => (
  <NotificationBadge
    notificationType={['placement_requests', 'placement_responded_requests']}
    className={className}
  />
);
